import * as Sentry from '@sentry/react';

/** An explicit lifetime/trace for work continuing in timers after a UI action. */
export function startBillingOperation(name) {
    const span = Sentry.startInactiveSpan({
        name: `billing.${name}`,
        op: 'ui.action',
        forceTransaction: true,
    });
    const context = span.spanContext();
    const id = crypto.randomUUID();
    let ended = false;
    return {
        id,
        context: { trace_id: context.traceId, span_id: context.spanId, op: 'ui.action' },
        headers: {
            'sentry-trace': Sentry.spanToTraceHeader(span),
            ...(Sentry.spanToBaggageHeader(span) && { baggage: Sentry.spanToBaggageHeader(span) }),
            'x-billing-operation-id': id,
        },
        end(success = true) {
            if (ended) return;
            ended = true;
            span.setStatus({ code: success ? 1 : 2 });
            span.end();
        },
    };
}
